/* Auto-generated. Do not edit manually. */
import { ReactComponent as Block_27_10 } from "../blocks/27/land_plot_block_10.svg";
import { ReactComponent as Block_27_11 } from "../blocks/27/land_plot_block_11.svg";
import { ReactComponent as Block_27_12 } from "../blocks/27/land_plot_block_12.svg";
import { ReactComponent as Block_27_13 } from "../blocks/27/land_plot_block_13.svg";
import { ReactComponent as Block_27_14 } from "../blocks/27/land_plot_block_14.svg";
import { ReactComponent as Block_27_15 } from "../blocks/27/land_plot_block_15.svg";
import { ReactComponent as Block_27_16 } from "../blocks/27/land_plot_block_16.svg";
import { ReactComponent as Block_27_17 } from "../blocks/27/land_plot_block_17.svg";
import { ReactComponent as Block_27_18 } from "../blocks/27/land_plot_block_18.svg";
import { ReactComponent as Block_27_19 } from "../blocks/27/land_plot_block_19.svg";
import { ReactComponent as Block_27_2 } from "../blocks/27/land_plot_block_2.svg";
import { ReactComponent as Block_27_20 } from "../blocks/27/land_plot_block_20.svg";
import { ReactComponent as Block_27_21 } from "../blocks/27/land_plot_block_21.svg";
import { ReactComponent as Block_27_22 } from "../blocks/27/land_plot_block_22.svg";
import { ReactComponent as Block_27_23 } from "../blocks/27/land_plot_block_23.svg";
import { ReactComponent as Block_27_24 } from "../blocks/27/land_plot_block_24.svg";
import { ReactComponent as Block_27_3 } from "../blocks/27/land_plot_block_3.svg";
import { ReactComponent as Block_27_4 } from "../blocks/27/land_plot_block_4.svg";
import { ReactComponent as Block_27_5 } from "../blocks/27/land_plot_block_5.svg";
import { ReactComponent as Block_27_7 } from "../blocks/27/land_plot_block_7.svg";
import { ReactComponent as Block_27_8 } from "../blocks/27/land_plot_block_8.svg";
import { ReactComponent as Block_27_9 } from "../blocks/27/land_plot_block_9.svg";
import { ReactComponent as Block_62_10 } from "../blocks/62/land_plot_block_10.svg";
import { ReactComponent as Block_62_11 } from "../blocks/62/land_plot_block_11.svg";
import { ReactComponent as Block_62_12 } from "../blocks/62/land_plot_block_12.svg";
import { ReactComponent as Block_62_13 } from "../blocks/62/land_plot_block_13.svg";
import { ReactComponent as Block_62_14 } from "../blocks/62/land_plot_block_14.svg";
import { ReactComponent as Block_62_15 } from "../blocks/62/land_plot_block_15.svg";
import { ReactComponent as Block_62_16 } from "../blocks/62/land_plot_block_16.svg";
import { ReactComponent as Block_62_17 } from "../blocks/62/land_plot_block_17.svg";
import { ReactComponent as Block_62_18 } from "../blocks/62/land_plot_block_18.svg";
import { ReactComponent as Block_62_19 } from "../blocks/62/land_plot_block_19.svg";
import { ReactComponent as Block_62_2 } from "../blocks/62/land_plot_block_2.svg";
import { ReactComponent as Block_62_20 } from "../blocks/62/land_plot_block_20.svg";
import { ReactComponent as Block_62_21 } from "../blocks/62/land_plot_block_21.svg";
import { ReactComponent as Block_62_22 } from "../blocks/62/land_plot_block_22.svg";
import { ReactComponent as Block_62_23 } from "../blocks/62/land_plot_block_23.svg";
import { ReactComponent as Block_62_24 } from "../blocks/62/land_plot_block_24.svg";
import { ReactComponent as Block_62_3 } from "../blocks/62/land_plot_block_3.svg";
import { ReactComponent as Block_62_4 } from "../blocks/62/land_plot_block_4.svg";
import { ReactComponent as Block_62_5 } from "../blocks/62/land_plot_block_5.svg";
import { ReactComponent as Block_62_7 } from "../blocks/62/land_plot_block_7.svg";
import { ReactComponent as Block_62_8 } from "../blocks/62/land_plot_block_8.svg";
import { ReactComponent as Block_62_9 } from "../blocks/62/land_plot_block_9.svg";
import { ReactComponent as Block_6_10 } from "../blocks/6/land_plot_block_10.svg";
import { ReactComponent as Block_6_11 } from "../blocks/6/land_plot_block_11.svg";
import { ReactComponent as Block_6_12 } from "../blocks/6/land_plot_block_12.svg";
import { ReactComponent as Block_6_13 } from "../blocks/6/land_plot_block_13.svg";
import { ReactComponent as Block_6_14 } from "../blocks/6/land_plot_block_14.svg";
import { ReactComponent as Block_6_15 } from "../blocks/6/land_plot_block_15.svg";
import { ReactComponent as Block_6_16 } from "../blocks/6/land_plot_block_16.svg";
import { ReactComponent as Block_6_17 } from "../blocks/6/land_plot_block_17.svg";
import { ReactComponent as Block_6_18 } from "../blocks/6/land_plot_block_18.svg";
import { ReactComponent as Block_6_19 } from "../blocks/6/land_plot_block_19.svg";
import { ReactComponent as Block_6_2 } from "../blocks/6/land_plot_block_2.svg";
import { ReactComponent as Block_6_20 } from "../blocks/6/land_plot_block_20.svg";
import { ReactComponent as Block_6_21 } from "../blocks/6/land_plot_block_21.svg";
import { ReactComponent as Block_6_22 } from "../blocks/6/land_plot_block_22.svg";
import { ReactComponent as Block_6_23 } from "../blocks/6/land_plot_block_23.svg";
import { ReactComponent as Block_6_24 } from "../blocks/6/land_plot_block_24.svg";
import { ReactComponent as Block_6_3 } from "../blocks/6/land_plot_block_3.svg";
import { ReactComponent as Block_6_4 } from "../blocks/6/land_plot_block_4.svg";
import { ReactComponent as Block_6_5 } from "../blocks/6/land_plot_block_5.svg";
import { ReactComponent as Block_6_7 } from "../blocks/6/land_plot_block_7.svg";
import { ReactComponent as Block_6_8 } from "../blocks/6/land_plot_block_8.svg";
import { ReactComponent as Block_6_9 } from "../blocks/6/land_plot_block_9.svg";
import { ReactComponent as Block_89_10 } from "../blocks/89/land_plot_block_10.svg";
import { ReactComponent as Block_89_11 } from "../blocks/89/land_plot_block_11.svg";
import { ReactComponent as Block_89_12 } from "../blocks/89/land_plot_block_12.svg";
import { ReactComponent as Block_89_13 } from "../blocks/89/land_plot_block_13.svg";
import { ReactComponent as Block_89_14 } from "../blocks/89/land_plot_block_14.svg";
import { ReactComponent as Block_89_15 } from "../blocks/89/land_plot_block_15.svg";
import { ReactComponent as Block_89_16 } from "../blocks/89/land_plot_block_16.svg";
import { ReactComponent as Block_89_17 } from "../blocks/89/land_plot_block_17.svg";
import { ReactComponent as Block_89_18 } from "../blocks/89/land_plot_block_18.svg";
import { ReactComponent as Block_89_19 } from "../blocks/89/land_plot_block_19.svg";
import { ReactComponent as Block_89_2 } from "../blocks/89/land_plot_block_2.svg";
import { ReactComponent as Block_89_20 } from "../blocks/89/land_plot_block_20.svg";
import { ReactComponent as Block_89_21 } from "../blocks/89/land_plot_block_21.svg";
import { ReactComponent as Block_89_22 } from "../blocks/89/land_plot_block_22.svg";
import { ReactComponent as Block_89_23 } from "../blocks/89/land_plot_block_23.svg";
import { ReactComponent as Block_89_24 } from "../blocks/89/land_plot_block_24.svg";
import { ReactComponent as Block_89_3 } from "../blocks/89/land_plot_block_3.svg";
import { ReactComponent as Block_89_4 } from "../blocks/89/land_plot_block_4.svg";
import { ReactComponent as Block_89_5 } from "../blocks/89/land_plot_block_5.svg";
import { ReactComponent as Block_89_7 } from "../blocks/89/land_plot_block_7.svg";
import { ReactComponent as Block_89_8 } from "../blocks/89/land_plot_block_8.svg";
import { ReactComponent as Block_89_9 } from "../blocks/89/land_plot_block_9.svg";

export const zone5_block_polygons = [
    {
        wrapperIndex: 2,
        areas: [
            {
                blockIndex: 2,
                Polygon: Block_6_2,
            },
            {
                blockIndex: 3,
                Polygon: Block_6_3,
            },
            {
                blockIndex: 4,
                Polygon: Block_6_4,
            },
            {
                blockIndex: 5,
                Polygon: Block_6_5,
            },
            {
                blockIndex: 7,
                Polygon: Block_6_7,
            },
            {
                blockIndex: 8,
                Polygon: Block_6_8,
            },
            {
                blockIndex: 9,
                Polygon: Block_6_9,
            },
            {
                blockIndex: 10,
                Polygon: Block_6_10,
            },
            {
                blockIndex: 11,
                Polygon: Block_6_11,
            },
            {
                blockIndex: 12,
                Polygon: Block_6_12,
            },
            {
                blockIndex: 13,
                Polygon: Block_6_13,
            },
            {
                blockIndex: 14,
                Polygon: Block_6_14,
            },
            {
                blockIndex: 15,
                Polygon: Block_6_15,
            },
            {
                blockIndex: 16,
                Polygon: Block_6_16,
            },
            {
                blockIndex: 17,
                Polygon: Block_6_17,
            },
            {
                blockIndex: 18,
                Polygon: Block_6_18,
            },
            {
                blockIndex: 19,
                Polygon: Block_6_19,
            },
            {
                blockIndex: 20,
                Polygon: Block_6_20,
            },
            {
                blockIndex: 21,
                Polygon: Block_6_21,
            },
            {
                blockIndex: 22,
                Polygon: Block_6_22,
            },
            {
                blockIndex: 23,
                Polygon: Block_6_23,
            },
            {
                blockIndex: 24,
                Polygon: Block_6_24,
            },
        ],
    },
    {
        wrapperIndex: 33,
        areas: [
            {
                blockIndex: 2,
                Polygon: Block_27_2,
            },
            {
                blockIndex: 3,
                Polygon: Block_27_3,
            },
            {
                blockIndex: 4,
                Polygon: Block_27_4,
            },
            {
                blockIndex: 5,
                Polygon: Block_27_5,
            },
            {
                blockIndex: 7,
                Polygon: Block_27_7,
            },
            {
                blockIndex: 8,
                Polygon: Block_27_8,
            },
            {
                blockIndex: 9,
                Polygon: Block_27_9,
            },
            {
                blockIndex: 10,
                Polygon: Block_27_10,
            },
            {
                blockIndex: 11,
                Polygon: Block_27_11,
            },
            {
                blockIndex: 12,
                Polygon: Block_27_12,
            },
            {
                blockIndex: 13,
                Polygon: Block_27_13,
            },
            {
                blockIndex: 14,
                Polygon: Block_27_14,
            },
            {
                blockIndex: 15,
                Polygon: Block_27_15,
            },
            {
                blockIndex: 16,
                Polygon: Block_27_16,
            },
            {
                blockIndex: 17,
                Polygon: Block_27_17,
            },
            {
                blockIndex: 18,
                Polygon: Block_27_18,
            },
            {
                blockIndex: 19,
                Polygon: Block_27_19,
            },
            {
                blockIndex: 20,
                Polygon: Block_27_20,
            },
            {
                blockIndex: 21,
                Polygon: Block_27_21,
            },
            {
                blockIndex: 22,
                Polygon: Block_27_22,
            },
            {
                blockIndex: 23,
                Polygon: Block_27_23,
            },
            {
                blockIndex: 24,
                Polygon: Block_27_24,
            },
        ],
    },
    {
        wrapperIndex: 61,
        areas: [
            {
                blockIndex: 2,
                Polygon: Block_62_2,
            },
            {
                blockIndex: 3,
                Polygon: Block_62_3,
            },
            {
                blockIndex: 4,
                Polygon: Block_62_4,
            },
            {
                blockIndex: 5,
                Polygon: Block_62_5,
            },
            {
                blockIndex: 7,
                Polygon: Block_62_7,
            },
            {
                blockIndex: 8,
                Polygon: Block_62_8,
            },
            {
                blockIndex: 9,
                Polygon: Block_62_9,
            },
            {
                blockIndex: 10,
                Polygon: Block_62_10,
            },
            {
                blockIndex: 11,
                Polygon: Block_62_11,
            },
            {
                blockIndex: 12,
                Polygon: Block_62_12,
            },
            {
                blockIndex: 13,
                Polygon: Block_62_13,
            },
            {
                blockIndex: 14,
                Polygon: Block_62_14,
            },
            {
                blockIndex: 15,
                Polygon: Block_62_15,
            },
            {
                blockIndex: 16,
                Polygon: Block_62_16,
            },
            {
                blockIndex: 17,
                Polygon: Block_62_17,
            },
            {
                blockIndex: 18,
                Polygon: Block_62_18,
            },
            {
                blockIndex: 19,
                Polygon: Block_62_19,
            },
            {
                blockIndex: 20,
                Polygon: Block_62_20,
            },
            {
                blockIndex: 21,
                Polygon: Block_62_21,
            },
            {
                blockIndex: 22,
                Polygon: Block_62_22,
            },
            {
                blockIndex: 23,
                Polygon: Block_62_23,
            },
            {
                blockIndex: 24,
                Polygon: Block_62_24,
            },
        ],
    },
    {
        wrapperIndex: 91,
        areas: [
            {
                blockIndex: 2,
                Polygon: Block_89_2,
            },
            {
                blockIndex: 3,
                Polygon: Block_89_3,
            },
            {
                blockIndex: 4,
                Polygon: Block_89_4,
            },
            {
                blockIndex: 5,
                Polygon: Block_89_5,
            },
            {
                blockIndex: 7,
                Polygon: Block_89_7,
            },
            {
                blockIndex: 8,
                Polygon: Block_89_8,
            },
            {
                blockIndex: 9,
                Polygon: Block_89_9,
            },
            {
                blockIndex: 10,
                Polygon: Block_89_10,
            },
            {
                blockIndex: 11,
                Polygon: Block_89_11,
            },
            {
                blockIndex: 12,
                Polygon: Block_89_12,
            },
            {
                blockIndex: 13,
                Polygon: Block_89_13,
            },
            {
                blockIndex: 14,
                Polygon: Block_89_14,
            },
            {
                blockIndex: 15,
                Polygon: Block_89_15,
            },
            {
                blockIndex: 16,
                Polygon: Block_89_16,
            },
            {
                blockIndex: 17,
                Polygon: Block_89_17,
            },
            {
                blockIndex: 18,
                Polygon: Block_89_18,
            },
            {
                blockIndex: 19,
                Polygon: Block_89_19,
            },
            {
                blockIndex: 20,
                Polygon: Block_89_20,
            },
            {
                blockIndex: 21,
                Polygon: Block_89_21,
            },
            {
                blockIndex: 22,
                Polygon: Block_89_22,
            },
            {
                blockIndex: 23,
                Polygon: Block_89_23,
            },
            {
                blockIndex: 24,
                Polygon: Block_89_24,
            },
        ],
    },
];